import React, { useMemo } from 'react'
import classnames from 'classnames'

import ProfileImage from 'components/ProfileImage'
import CopyPublicProfileLink from 'components/CopyPublicProfileLink'
import { GENDERS, PREFERENCES } from 'constants/user'
import { dateFormatter, constants } from 'helpers'

const {
  EVENT_CONSTANTS: {
    STATUS: { COMPLETED, ARCHIVED },
  },
} = constants

const HostPortalListItem = ({
  attendee,
  deleteSignup,
  isPaidEvent,
  eventStatus,
  isBachelorette,
}) => {
  const { age, isEventOver } = useMemo(
    () => ({
      age: dateFormatter.getAgeFromBirthdate(attendee.birthdate),
      isEventOver: [COMPLETED, ARCHIVED].includes(eventStatus),
    }),
    [eventStatus, attendee]
  )
  return (
    <div
      key={attendee.id}
      className={classnames('bg-white border border-white shadow-lg rounded-3xl p-4 mt-4', {
        'border-solid border-red-500': isBachelorette,
      })}
    >
      <div className="flex flex-col sm:flex-row">
        <div className=" relative h-32 w-32 sm:mb-0 mb-3">
          <ProfileImage
            src={attendee.profileImage}
            alt={attendee.name}
            className=" w-32 h-32 object-cover rounded-2xl"
          />
        </div>
        <div className="flex flex-col w-full sm:ml-5">
          <div className="flex items-center space-x-2">
            <div className="flex-none text-lg text-gray-800 font-bold leading-none">
              {attendee.id} - {attendee.name}
            </div>
            <CopyPublicProfileLink username={attendee.username || attendee.id} />
          </div>
          <div className="flex flex-col text-gray-500 justify-between mt-1">
            <Property label="Age">{age}</Property>
            <Property label="Gender">{GENDERS[attendee.gender]}</Property>
            <Property label="Preference">{PREFERENCES[attendee.genderPreference]}</Property>
            <Property label="Email">{attendee.email}</Property>
            <Property label="Phone Number">{attendee.phoneNumber}</Property>
            <Property label="Location">{attendee.location}</Property>
            {!isBachelorette && !isEventOver && (
              <div className="flex justify-end space-x-2">
                {isPaidEvent && (
                  <DeleteButton onClick={() => deleteSignup(attendee.id, true)}>
                    Refund
                  </DeleteButton>
                )}
                <DeleteButton onClick={() => deleteSignup(attendee.id, false)}>Delete</DeleteButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const Property = ({ label, children }) => (
  <div className="flex my-1">
    <span className="mr-2 font-semibold">{label}:</span>
    <span>{children}</span>
  </div>
)

const DeleteButton = props => (
  <button
    className="flex-no-shrink bg-red-400 hover:bg-red-500 px-5 py-2 text-xs shadow-sm hover:shadow-lg tracking-wider border-2 border-red-300 hover:border-red-500 text-white font-bold rounded-full transition ease-in duration-300"
    {...props}
  />
)

export default HostPortalListItem
